import { HttpTypes } from '@medusajs/types'

// Transforme les options d'une variante (liste option_id/value) en objet { option_id: value },
// plus pratique pour comparer ou retrouver une variante à partir des options sélectionnées.
export const optionsAsKeymap = (
  variantOptions: HttpTypes.StoreProductVariant['options'] | undefined | null,
) =>
  variantOptions?.reduce<Record<string, string>>((acc, optionValue) => {
    if (optionValue.option_id) acc[optionValue.option_id] = optionValue.value
    return acc
  }, {}) ?? {}
